import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";

export const FeedHealthSummary = ({
  weak,
  fair,
  total,
  onShowWeak
}: {
  weak: number;
  fair: number;
  total: number;
  onShowWeak: () => void;
}) => (
  <Show if={weak > 0 || fair > 0}>
    <div className="mt-3 flex flex-wrap items-center gap-x-1 text-sm font-medium text-content-700">
      <span>
        {weak > 0 ? (
          <>
            {weak} of {total} listings in this feed are{" "}
            <b className="text-content-1000">Weak</b>
            {fair > 0 ? (
              <>
                {" "}
                and {fair} are <b className="text-content-1000">Fair</b>
              </>
            ) : null}
            .
          </>
        ) : (
          <>
            {fair} of {total} listings in this feed are{" "}
            <b className="text-content-1000">Fair</b>.
          </>
        )}
      </span>
      <Show if={weak > 0}>
        <Button
          variant={ButtonVariant.TEXT}
          size={ButtonSize.SM}
          className="!h-auto !px-1"
          onClick={onShowWeak}
        >
          Show Weak listings
        </Button>
      </Show>
    </div>
  </Show>
);
